import moment from "moment";

export default class TempusDominusComponent {
	constructor() {
		this.init();
	}

	init() {
		let parent = this;

		document.querySelectorAll("input[data-provide='datepicker']:not([data-datepicker-init='1'])").forEach(function (item, key) {
			item.setAttribute('data-datepicker-init', "1");

			parent.initTempusDominus(
				item,
				{
					localization: {
						format: 'dd. MM. yyyy'
					},
					display: {
						components: {
							decades: true,
							year: true,
							month: true,
							date: true,
							hours: false,
							minutes: false,
							seconds: false
						}
					}
				},
				'DD. MM. YYYY'
			)
		});

		document.querySelectorAll("input[data-provide='datetimepicker']:not([data-datepicker-init='1'])").forEach(function (item, key) {
			item.setAttribute('data-datepicker-init', "1");

			parent.initTempusDominus(
				item,
				{
					localization: {
						format: 'dd. MM. yyyy h:mm'
					},
					display: {
						components: {
							decades: true,
							year: true,
							month: true,
							date: true,
							hours: true,
							minutes: true,
							seconds: true
						}
					}
				},
				'DD. MM. YYYY HH:MM'
			)
		});
	}

	initTempusDominus(item, customConfig, format) {
		const defaultValue = item.value;
		// Kvůli jinému formátu datumu musíme před inicializací vymazat input
		item.value = '';

		let config = mergeDeep({
			localization: {
				today: 'Přejít na dnešek',
				clear: 'Vyčistit',
				close: 'Zavřít',
				selectMonth: 'Vybrat',
				previousMonth: 'Předchozí měsíc',
				nextMonth: 'Příští měsíc',
				selectYear: 'Vybrat rok',
				previousYear: 'Předchozí rok',
				nextYear: 'Příští rok',
				selectDecade: 'Vyberte desetiletí',
				previousDecade: 'Předchozí desetiletí',
				nextDecade: 'Příští desetiletí',
				previousCentury: 'Předchozí století',
				nextCentury: 'Příští století',
				pickHour: 'Vybrat',
				incrementHour: 'Přidat',
				decrementHour: 'Snížit',
				pickMinute: 'Vybrat',
				incrementMinute: 'Přidat',
				decrementMinute: 'Snížit',
				pickSecond: 'Vybrat',
				incrementSecond: 'Přidat',
				decrementSecond: 'Snížit',
				toggleMeridiem: 'Přepínání Meridiem',
				selectTime: 'Vybrat',
				selectDate: 'Vybrat',
				dayViewHeaderFormat: {month: 'long', year: 'numeric'},
				startOfTheWeek: 1,
				hourCycle: undefined,
				ordinal: (n) => n,
				locale: 'cs-Cz'
			},
			display: {
				viewMode: "calendar",
				sideBySide: false,
				calendarWeeks: false,
				toolbarPlacement: 'bottom',
				keepOpen: false,
				inline: false,
				icons: {
					time: "far fa-clock",
					date: "far fa-calendar",
					up: "fas fa-arrow-up",
					down: "fas fa-arrow-down",
					previous: "fas fa-chevron-left",
					next: "fas fa-chevron-right",
					today: "far fa-calendar-check",
					clear: "far fa-trash",
					close: "far fa-xmark",
				},
				buttons: {
					today: true,
					clear: true,
					close: true,
				},
			},
			keepInvalid: false,
			stepping: 1,
			useCurrent: true,
			meta: {},
			multipleDates: false,
			multipleDatesSeparator: ';',
			promptTimeOnDateChange: false,
			promptTimeOnDateChangeTransitionDelay: 200,
			restrictions: {
				minDate: undefined,
				maxDate: undefined,
				disabledDates: [],
				enabledDates: [],
				daysOfWeekDisabled: [],
				disabledTimeIntervals: [],
				disabledHours: [],
				enabledHours: []
			}
		}, customConfig);

		if (item.hasAttribute('min')) {
			config = mergeDeep(config, {
				restrictions: {
					minDate: moment(item.getAttribute('min')).format(format)
				}
			});
		}

		if (item.hasAttribute('max')) {
			config = mergeDeep(config, {
				restrictions: {
					maxDate: moment(item.getAttribute('max')).format(format)
				}
			});
		}

		let picker = new window.tempusDominus.TempusDominus(item, config);

		if (defaultValue) {
			picker.dates.setValue(tempusDominus.DateTime.convert(moment(defaultValue).toDate()));
		}

		picker.dates.formatInput = date => {
			{
				return date
					? moment(date).format(format)
					: null;
			}
		};

		item.addEventListener('hide.td', function (i) {
			Nette.validateControl(document.getElementById($(this).attr('id')));
		});
	}

}